import {useEffect, useState} from "react";
import {
    ThinAccountBalanceIcon,
    ThinAddIcon,
    ThinCloseIcon,
    ThinRemoveIcon, TomansIcon
} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CurrencyFormat, NumberToPersianLetters, ToxicInputNumberOnly} from "../../../components/techaran/money";
import {Apis} from "../../../components/api/url";

export const AddBalanceModal = (props:{active:boolean,closeHandler:any,onDone:any,currentBalance:number,studentId:string,customerName:string}) => {
    useEffect(() => {
        const isActive = props.active;
        if(isActive) {
            document.body.classList.add('body-no-scroll');
            setMode('+');
            setAmount('5000');
        }
        else
            document.body.classList.remove('body-no-scroll');
    }, [props.active]);
    const [mode,setMode] = useState('+' as "+"|'-');
    const [amount,setAmount] = useState('0');
    const saveCredit = () => {
        const isNeg = mode === '-';
        const _amount = amount;
        const studentId = props.studentId;
        if(_amount === ''){
            ShowSnackbar(
                'مبلغ افزایش اعتبار نمی‌تواند خالی باشد.',
                'باشه',
                5000,
            );
            return;
        }
        const _amountInt = parseInt(_amount);
        if(_amountInt === 0){
            ShowSnackbar(
                'مبلغ افزایش اعتبار باید بیشتر باشد.',
                'باشه',
                5000,
            );
            return;
        }
        const _current = props.currentBalance;
        if(isNeg && parseInt(_amount) > _current){
            ShowSnackbar('موجودی نهایی کارمند نمی‌تواند کمتر از صفر شود.','باشه',5000);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/point/increase',
            {
                n:isNeg ? '1' : '0',
                p:_amount.toString(),
                id:studentId,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK')
                    return;
                props.closeHandler();
                props.onDone();
                ShowSnackbar(
                    'موجودی حساب جدید ذخیره شد.',
                    'باشه',
                    5000,
                );
            },
            ()=>{
                ShowConnectionFailed('fa');
                props.closeHandler();
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void(0));
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active':'')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active? ' active':'')} style={{top:20}}>
                <div className="web-modal-header">
                    <div>
                        <ThinAccountBalanceIcon/>
                        <b>{mode === '+' ? 'افزایش اعتبار حساب':'کاهش اعتبار حساب'}</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="crm-credit-modal">
                        <div className="crm-credit-modal-tabs" data-color={mode === "+" ? 'green':'red'}>
                            <button className={mode === '+' ? "active" : ''} onClick={()=>setMode('+')}>
                                <ThinAddIcon/>
                                <span>افزایش موجودی</span>
                            </button>
                            <button className={mode === '-' ? 'active':''} onClick={()=>setMode('-')}>
                                <ThinRemoveIcon/>
                                <span>کاهش موجودی</span>
                            </button>
                        </div>
                        <div data-color={mode === '+' ? "green" : 'red'}>
                            <div className="crm-credit-modal-price">
                                <button onClick={()=>setAmount(e=> {
                                    let x= e === '' ? 0 : parseInt(e);
                                    return x - 5000 > 0 ? (x - 5000).toString() : '0';
                                })}>
                                    <ThinRemoveIcon/>
                                </button>
                                <input type="number" className="f-roboto"
                                       value={amount}
                                       min={0}
                                       step={500}
                                       onChange={e=>{
                                           let t = e.currentTarget.value;
                                           t = ToxicInputNumberOnly(t);
                                           if(t.trim() === '')
                                               setAmount('');
                                           else
                                               setAmount((parseInt(t) + 1 - 1).toString());
                                       }}
                                />
                                <button onClick={()=>setAmount(e=> {
                                    let x= e === '' ? 0 : parseInt(e);
                                    return (x + 5000).toString();
                                })}>
                                    <ThinAddIcon/>
                                </button>
                            </div>
                            <span className="crm-credit-modal-amount-text">{mode === '+' ? 'افزایش':'کاهش'} به مقدار {NumberToPersianLetters(amount === '' ? 0 : parseInt(amount))} تومان</span>
                            <div className="crm-credit-modal-preview">
                                <span className="f-roboto">{
                                    mode === '+' ?
                                        'موجودی حساب پس از افزایش اعتبار':
                                        'موجودی حساب پس از کاهش اعتبار'
                                }:</span>
                                <b>
                                    <span>
                                        {(()=>{
                                            const _mode = mode;
                                            const _amount = amount;
                                            const _budget = props.currentBalance;
                                            let x = _mode === '+' ? (_budget + (_amount === '' ? 0 : parseInt(_amount))) : (_budget - (_amount === '' ? 0 : parseInt(_amount)));
                                            return (
                                                <>
                                                    {x < 0 && false ? '-':''}
                                                    {CurrencyFormat(x).replace('-','')}
                                                    {x < 0 && true ? '-':''}
                                                </>
                                            );
                                        })()}
                                    </span>
                                    <TomansIcon/>
                                </b>
                            </div>
                            <div className="crm-credit-modal-ready">
                                {
                                    [5000,10000,20000,50000,70000,100000,150000,200000].map((p,i)=>
                                        <button
                                            className={amount === p.toString() ? 'active':''}
                                            onClick={()=>setAmount(p.toString())}
                                            key={"Jc2WfO94XdI"+i}>{CurrencyFormat(p)}</button>
                                    )
                                }
                            </div>
                            <div className="crm-credit-modal-cta">
                                <button data-i="0" onClick={props.closeHandler}>
                                    <span>انصراف</span>
                                </button>
                                <button data-i="1" onClick={saveCredit}>
                                    <span>اعمال تراکنش</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};